import React from "react";
import { Stack, Typography } from "@mui/material";
import { overlineSx } from "./cardChrome";

/**
 * The overline above a group of cards, with an optional hint at the right
 * ("Setup · 4 of 6 complete", "Laser systems · All accounts").
 */
export default function GroupLabel({ label, hint }) {
  return (
    <Stack direction="row" justifyContent="space-between" alignItems="baseline" sx={{ px: 0.5, pt: 0.5 }}>
      <Typography variant="overline" sx={overlineSx}>
        {label}
      </Typography>
      {hint ? (
        <Typography variant="caption" sx={{ color: "text.secondary", fontWeight: 600 }}>
          {hint}
        </Typography>
      ) : null}
    </Stack>
  );
}
